import React from 'react';
import { Link } from "gatsby";

const SearchAll = ({hit}) => {
    return (
        <>
            <Link to={hit.url} className="flex gap-4">
                    <div className="search-content">
                        <div className="items-center gap-1 display-initial">
                            {/* {hit.data.resource_label ? hit.data.resource_label : ''} */}
                            <span className="title">{hit.data.title.text}</span><br />
                            <span className="desc">{hit.data.description.text}</span>
                            </div>
                    </div>
            </Link>
        </>
    );
}

export default SearchAll;
